import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Section } from "../components/ui";
import ProjectCard from "../components/ProjectCard";
import { workGroups } from "../data/projects";

const WorkCategory = () => {
  const { category } = useParams();
  const group = workGroups.find((g) => g.id === category);

  if (!group) return <Navigate to="/work" replace />;

  return (
    <main>
      <Section className="!pb-10 sm:!pb-12">
        <Link
          to="/work"
          className="inline-flex items-center gap-1 text-sm font-medium text-ink-soft hover:text-accent"
        >
          <ArrowLeft className="h-4 w-4" /> All work
        </Link>
        <div className="mt-6 flex flex-wrap gap-x-2 gap-y-1 text-sm text-ink-faint">
          {workGroups.map((g, i) => (
            <React.Fragment key={g.id}>
              {i > 0 && <span>/</span>}
              {g.id === category ? (
                <span className="font-medium text-accent">{g.label}</span>
              ) : (
                <Link to={`/work/${g.id}`} className="hover:text-ink">
                  {g.label}
                </Link>
              )}
            </React.Fragment>
          ))}
        </div>
        <h1 className="mt-3 max-w-2xl text-4xl font-black leading-tight tracking-tight text-ink sm:text-5xl">
          {group.title}
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-ink-soft">{group.intro}</p>
      </Section>

      <Section tone="panel" className="!pt-0 sm:!pt-0">
        <div className="border-t border-line pt-10 sm:pt-12">
          {group.items.map((p) => (
            <ProjectCard key={p.title} project={p} id={p.title.toLowerCase().replace(/\s+/g, "-")} />
          ))}
        </div>
      </Section>
    </main>
  );
};

export default WorkCategory;
